import { render } from "./ListIzinView.vue?vue&type=template&id=56e426f2"
import script from "./ListIzinView.vue?vue&type=script&lang=js"
export * from "./ListIzinView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__